/**
 * Live-QA fixes, U2 — the shared guard behind "click anywhere in a row/card
 * header to expand it": a click that landed on (or inside) a real
 * interactive control must NOT also toggle the header's own expand/collapse,
 * or every button in the header would double-fire its own action plus a
 * toggle. `[role="menu"]`/`[role="menuitem"]` covers a `KebabMenu`'s trigger
 * indirectly (its trigger is a real `<button>`, already covered) and guards
 * against a future menu implementation that renders its trigger as
 * something else. `[data-row-control]` is an escape hatch for a control that
 * needs the guard but isn't a `button`/`a`/`input`/menu role.
 *
 * Root cause this module fixes: `QualifyStep.tsx` and `SequencesStep.tsx`
 * each carried a verbatim copy of this predicate keyed on
 * `target instanceof HTMLElement`. Glaze's `IconButton` renders a real
 * `<button>`, but the caret's visible click surface is the Phosphor `<svg>`
 * inside it — an `Element`, not an `HTMLElement` — so a click on the glyph
 * failed the old guard, the row's own header handler toggled, AND the
 * caret's own `onClick` toggled, and the two cancelled each other out.
 * `instanceof Element` covers SVG/path targets; the module is safe to import
 * under `bun test`, which has no DOM globals at all.
 */
export function isInteractiveRowTarget(target: EventTarget | null): boolean {
  return (
    typeof Element !== 'undefined' &&
    target instanceof Element &&
    target.closest('button, a, input, [role="menu"], [role="menuitem"], [data-row-control]') !== null
  );
}
